{
    "NAME": "DeviceModal",
    "DeviceModal_AddTitle": "Add Device",
    "DeviceModal_ChangeTitle": "Change Device",
    "DeviceModal_ViewTitle": "View Device",
    "DeviceModal_PromptMessage": "You have unsaved device changes. Exit without saving?",
    "DeviceModal_PromptConfirm": "Exit",
    "DeviceModal_PromptCancel": "Cancel",
    "DeviceModal_Tab_General": "Details",
    "DeviceModal_Tab_Advanced": "Advanced",
    "DeviceModal_Tab_Monitoring": "Monitoring",
    "DeviceModal_Tab_DeviceMembers": "Device Members",
    "DeviceModal_Tab_AgentMembers": "Agent Members",
    "DeviceModal_Tab_DnisMembers": "DNIS",
    "DeviceModal_Tab_LinkedEntities": "Linked Entities",
    "DeviceModal_Loading": "Loading...",
    "DeviceModal_Button_Close": "Close",
    "DeviceModal_Button_Cancel": "Cancel",
    "DeviceModal_Button_Save": "Save",
    "DeviceModal_RequestFailed": "Request failed",
    "DeviceModal_General_IdentifierGuid": "Identifier (GUID)",
    "DeviceModal_General_IdentifierPlaceholder": "[Auto assigned]",
    "DeviceModal_General_GuidPendingHelp": "The identifier is assigned after the device is saved.",
    "DeviceModal_General_DeviceNumber": "Device Number",
    "DeviceModal_General_DeviceNumberRequired": "Device Number is required",
    "DeviceModal_General_Description": "Description",
    "DeviceModal_General_DescriptionRequired": "Description is required",
    "DeviceModal_General_DeviceType": "Device Type",
    "DeviceModal_General_DeviceTypeRequired": "Device type is required",
    "DeviceModal_General_Partition": "Partition",
    "DeviceModal_General_PartitionRequired": "Partition is required",
    "DeviceModal_General_None": "None",
    "DeviceModal_General_IDOnTelSys": "ID on Telephony Server",
    "DeviceModal_General_IDOnTelSys_Broadworks": "BroadWorks User ID",
    "DeviceModal_General_IDOnTelSys_Webex": "Webex Calling User ID",
    "DeviceModal_General_IDOnTelSys_MsTeams": "MSTeams User ID",
    "DeviceModal_General_IDOnTelSys_Panasonic": "ID On Telephony Server",
    "DeviceModal_General_IDOnTelSys_M6": "OID On Telephone Server",
    "DeviceModal_General_IDOnTelSysOwner": "Owning Group ID",
    "DeviceModal_General_IDOnTelSysDivision": "Owning Department (Full Path)",
    "DeviceModal_General_InternalExtension": "Internal Dialling Address",
    "DeviceModal_General_TelSysUserID": "Telephony Server User ID",
    "DeviceModal_General_TelSysUserID_WebexCiscoCommonIdentity": "Cisco Common Identity",
    "DeviceModal_General_TelSysUserID_MsTeamsUpnUrn": "User Principal Name (URN)",
    "DeviceModal_General_TelSysPassword": "Telephony Server Password",
    "DeviceModal_General_TelSysMonitorPassword": "Monitor Password",
    "DeviceModal_General_PrimaryEmail": "Primary Email Address",
    "DeviceModal_General_UpdateExistingItems": "Update existing items if duplicates are found",
    "DeviceModal_Monitoring_OverrideMonitoring": "Override Monitoring (Unmonitored)",
    "DeviceModal_Monitoring_DisableRTMonitoring": "Disable Real-Time Monitoring",
    "DeviceModal_Members_DeviceNumber": "Device Number",
    "DeviceModal_Members_Description": "Description",
    "DeviceModal_Members_AgentNumber": "Agent Number",
    "DeviceModal_Members_Actions": "Actions",
    "DeviceModal_Members_Add": "Add member",
    "DeviceModal_Members_AddHotkey": "Add member (Ctrl+Enter)",
    "DeviceModal_Members_Remove": "Remove member",
    "DeviceModal_Members_Search": "Search members",
    "DeviceModal_Members_NoDeviceMembers": "No device members",
    "DeviceModal_Members_NoAgentMembers": "No agent members",
    "DeviceModal_Members_DnisNumber": "DNIS number",
    "DeviceModal_Members_AddDnis": "Add DNIS",
    "DeviceModal_Members_AddDnisHotkey": "Add DNIS (Ctrl+Enter)",
    "DeviceModal_Members_NoDnisMembers": "No DNIS associations",
    "DeviceModal_LinkedEntities_Loading": "Loading linked entities…",
    "DeviceModal_LinkedEntities_Empty": "None",
    "DeviceModal_LinkedEntities_Section_Groups": "Group memberships",
    "DeviceModal_LinkedEntities_Section_Users": "Associated users",
    "DeviceModal_LinkedEntities_Column_GroupId": "Group",
    "DeviceModal_LinkedEntities_Column_Description": "Description",
    "DeviceModal_LinkedEntities_Column_UserId": "User"
}
